import React, { Component } from "react";
import { Alert, Container } from "reactstrap";
import { RouterProps, Styled } from "../../../../toolkit/decorators/Artifact";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import {
  Inputs,
  Buttons,
  formConfig,
  selectClubFormConfig
} from "./ReporteLider.form";
import { ReporteLiderTable } from "./ReporteLider.table";
import FormBuilderModal from "../../common/formBuilderModal/formBuilderModal";
import { ReporteLiderDispatcher } from "../../../containers/comisionesMembresia/reporteLider/ReporteLider.dispatcher";
import { ReporteLiderStore } from "../../../containers/comisionesMembresia/reporteLider/ReporteLider.store";
import { errorNotification } from "../../../../utils/notifications";
import { Preview } from "../../../../types/IAction";
import { GetLiderClubes } from "../../../reducers/comisionMembresia";
import s from "./styles.scss";

interface Props
  extends ReporteLiderDispatcher,
    ReporteLiderStore,
    RouterProps {}

interface State {
  periodo: string;
  idLider: number;
  selectClubOpen: boolean;
  clubOptions: { value: number; label: string }[];
}

@Styled(s)
export default class ReporteLiderComponent extends Component<Props, State> {
  state: State = {
    periodo: null,
    idLider: null,
    selectClubOpen: false,
    clubOptions: []
  };

  submit = async (data: { [key in Inputs]: any }) => {
    const periodo = `${data.anio || new Date().getFullYear()}-${data.mes}-01`;
    const idLider = data.idLider ? parseInt(data.idLider as any) : undefined;

    this.setState({ periodo, idLider });

    const preview: Preview<GetLiderClubes> = await this.props.getClubesByLider(
      periodo,
      idLider
    );

    if (!preview.fulfilled) {
      errorNotification(preview.gettingLiderClubesError);
      return;
    }

    const clubes: any[] = preview.liderClubes || [];

    if (clubes.length === 0) {
      return;
    }

    if (clubes.length === 1) {
      this.fetchReporte(periodo, clubes[0].idClub, idLider);
      return;
    }

    // Más de un club: mostrar popup de selección
    this.setState({
      selectClubOpen: true,
      clubOptions: clubes.map(c => ({ value: c.idClub, label: c.club }))
    });
  };

  fetchReporte = async (periodo: string, idClub: number, idLider?: number) => {
    const preview = await this.props.getReporteByLiderClub(
      periodo,
      idClub,
      idLider
    );

    if (!preview.fulfilled) {
      errorNotification(preview.gettingLiderReporteError);
    }
  };

  handleSelectClub = (data: { idClub: any }) => {
    const { periodo, idLider } = this.state;
    this.setState({ selectClubOpen: false });
    this.fetchReporte(periodo, parseInt(data.idClub as any), idLider);
  };

  render() {
    const { selectClubOpen, clubOptions } = this.state;
    const {
      liderReporte,
      gettingLiderReporte,
      gettingLiderClubes,
      gettingLiderClubesError,
      gettingLiderReporteError
    } = this.props;

    const loading = gettingLiderClubes || gettingLiderReporte;

    const dynamicSelectClubConfig = {
      ...selectClubFormConfig,
      inputs: selectClubFormConfig.inputs.map(input =>
        input.name === "idClub"
          ? { ...input, props: { ...input.props, data: clubOptions } }
          : input
      )
    };

    return (
      <Container>
        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.submit}
          processing={loading}
        />

        {gettingLiderClubesError && !loading && (
          <Alert color="warning" className="mt-3">
            {gettingLiderClubesError}
          </Alert>
        )}

        {gettingLiderReporteError && !loading && (
          <Alert color="danger" className="mt-3">
            {gettingLiderReporteError}
          </Alert>
        )}

        {liderReporte && !loading && (
          <ReporteLiderTable reporte={liderReporte} loading={loading} />
        )}

        <FormBuilderModal
          isOpen={selectClubOpen}
          title="Seleccione el Club"
          message="El líder tiene asignados varios clubes en el periodo. Seleccione el club que desea consultar."
          ok={this.handleSelectClub}
          cancel={() => this.setState({ selectClubOpen: false })}
          formConfig={dynamicSelectClubConfig as any}
          values={{ idClub: "" }}
        />
      </Container>
    );
  }
}
